import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-groundMarkLine",
  "use": "icon-groundMarkLine-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-groundMarkLine\">\n<g>\n\t<polygon fill-rule=\"evenodd\" clip-rule=\"evenodd\" points=\"61.236,74.16 177.526,74.16 138.764,125.84 22.474,125.84 \t\" />\n\t<polygon fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFF100\" points=\"99.999,74.16 138.762,74.16 100.001,125.84 \n\t\t61.238,125.84 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol